import React from 'react';
import DOMPurify from 'dompurify';

const ContentHTML = ({ htmlContent }) => {
  const sanitizedHTML = DOMPurify.sanitize(htmlContent);

  return (
    <div className="HTML-Displayer" dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />
  );
};

export default ContentHTML;